<div class="basicrow m-top-i">
  <div class="row dashboard">	
    <ng-container *ngFor="let module of this.modulesobj['modules']; let i = index" >
      <div class="dashconts" *ngIf="module.status2=='True' && module.type==this.type">
        <a  class="dashbox {{module.color}} vcenter ext-n"  (click)="goTo(module.path)">
          <span class="tabcell">
            <span class="{{module.cssimage}}"></span>
             {{module.name2}}
          </span>
        </a>
      </div>
    </ng-container>
  </div>
</div>